import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "content",
  class: "app-dialog__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: _ctx.teleportId }, [
    _createVNode(_Transition, {
      css: false,
      appear: "",
      onAppear: _ctx.onAppear,
      onEnter: _ctx.onEnter,
      onLeave: _ctx.onLeave
    }, {
      default: _withCtx(() => [
        (_ctx.isDialogOpen)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({
              key: 0,
              class: "app-dialog"
            }, _ctx.$attrs), [
              _createElementVNode("div", {
                ref: "backdrop",
                class: "app-dialog__backdrop",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackdropClick && _ctx.onBackdropClick(...args)))
              }, null, 512),
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ close: _ctx.close })))
              ], 512)
            ], 16))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onAppear", "onEnter", "onLeave"])
  ], 8, ["to"]))
}